import fetchManager from '@utils/fetchManager'
import { getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");
// const API_URL = 'http://localhost:8083'

export default {
  getTypeUsers: async () => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/typeUsers`)
    return response
  },
  
  updateRestringir: async (typeUser, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/typeUsers/restringir/${typeUser}`, {
      method: 'PATCH',
      data,
    })
    return response
  },

  getSectionsLocked: async (typeUser) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/typeUsers/sections-locked/${typeUser}`)
    return response
  },

  updateSectionsLocked: async (typeUser, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/typeUsers/sections-locked/${typeUser}`, {
      method: 'PUT',
      data,
    })
    return response
  },
}
